const BASE_URL = import.meta.env.VITE_APP_BASE_URL;
const SIGNUP_PROVIDER_STORAGE_KEY = "signup_provider";

export { BASE_URL, SIGNUP_PROVIDER_STORAGE_KEY };
